import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ngx-card-layout',
  templateUrl: './ngx-card-layout.component.html',
  styleUrls: ['./ngx-card-layout.component.scss']
})
export class NgxCardLayoutComponent implements OnInit {

  @Input() header: string;
  @Input() headerIcon: string;

  constructor() { }

  ngOnInit(): void {
  }

}
